import { HttpService } from '@/shared/lib'

export class GetProdutoDisponivel extends HttpService {
  async execute(idExternoProduto: number) {
    return this.http.get<boolean>(`/api/v2/Produto/${idExternoProduto}/disponivelParaSimulacao`)
  }
}
